<template>
	<div :class="[$style.wrapper, 'd-flex align-center']">
		<div class='ao-c4 mr-2 ao-text-600 my-auto'>Рейтинг: </div>
		<v-rating
			:modelValue='modelValue'
			:half-increments='halfIncrements'
			:clearable='clearable'
			@update:modelValue="$emit('update:modelValue', $event)"
		>
			<template v-slot:item='{ isFilled }'>
				<ao-icon
					iconName='star'
					:class='[$style.icon, isFilled && $style.filled]'
				/>
			</template>
		</v-rating>
	</div>
</template>

<script>
export default {
	name: 'AoRatings',

	props: {
		modelValue: Number,
		clearable: Boolean,
		halfIncrements: Boolean,
	},

	emits: ['update:modelValue'],
}
</script>

<style module lang='scss'>
.wrapper {
	:global(.ao-icon) {
		vertical-align: unset;
		&:hover {
			border-radius: 100px;
			background: #F0F4F7;
		}
	}
	:global(.v-rating__item) {
		height: 16px;
		margin-top: -1px;
	}
	:global(.v-rating__wrapper) {
		margin-right: 2px;
		height: 16px;
	}
	:global(.v-rating__hidden) {
		display: none;
	}

	.icon {
		color: #D3D9E0;
	}

	.icon.filled {
		color: #EAB631;
	}
}
</style>
